import type {HelpFile} from '../../types/help'
import {SourcesCardTestIds} from '../../../testids/SourcesCardTestIds'

export const sourcesCardHelp: HelpFile = {
  docPage: '/docs/admin/multi-source-sync',
  texts: {
    [SourcesCardTestIds.sectionSources]:
      'External target systems that have synced this record at least once. Each row shows the system name, the external ID it uses for this record, and how recently it was last seen.',
    [SourcesCardTestIds.sourcesEmpty]:
      'This record has not been synced from any external system yet. It was created manually inside IAM. The next inbound sync that correlates to this record will add a source row here.',
    [SourcesCardTestIds.sourcesError]:
      'The sources list could not be loaded. The "Retry" button repeats the request — if the problem persists, check the error log for details.',
    [SourcesCardTestIds.sourcesLoading]: null,
    [SourcesCardTestIds.sourcesRetry]: null,
    [SourcesCardTestIds.detachSourceDialog]:
      'Detach unlinks this source from the record. Any attribute currently owned by this system is released — manual edits become possible until the next sync that touches the attribute claims authority again. The next sync from this system treats the record as new and may create a duplicate if correlation fails.',
    [SourcesCardTestIds.detachSourceCancel]: null,
    [SourcesCardTestIds.detachSourceConfirm]:
      'Detach is destructive — confirm only when you understand the consequences. The action cannot be undone in bulk.',
    [SourcesCardTestIds.bulkReleaseDialog]:
      'Release all attributes owned by this system on this record. Each attribute becomes editable from any source. The next inbound sync that writes to a released attribute claims authority again automatically. Useful when decommissioning a connector.',
    [SourcesCardTestIds.bulkReleaseCancel]: null,
    [SourcesCardTestIds.bulkReleaseConfirm]:
      'Release all attributes. Use the amber/warning button — releasing is reversible (the next sync may claim authority again).',
  },
}
